// extracted by mini-css-extract-plugin
module.exports = {"accountForm":"account_accountForm__246Lo","passwordHeader":"account_passwordHeader__1AiRB"};